import React, { useState } from 'react';
import { Container, Row, Col, Toast, ToastContainer } from 'react-bootstrap';
import { contactData, createWelcomeWhatsappUrl, createContactFormWhatsappUrl } from '../data/contactData';
import { createOrderMessengerUrl } from '../data/orderFormData';
import './ContactPage.css';

const ContactPage = ({ onNavigate }) => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    message: ''
  });

  const [errors, setErrors] = useState({});
  const [showToast, setShowToast] = useState(false);

  // تحديث البيانات عند تغيير الحقول
  const handleInputChange = (field, value) => {
    setFormData(prev => ({
      ...prev,
      [field]: value
    }));
    
    // إزالة الخطأ عند التعديل
    if (errors[field]) {
      setErrors(prev => ({
        ...prev,
        [field]: ''
      }));
    }
  };

  // التحقق من صحة البيانات
  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) {
      newErrors.name = 'الاسم مطلوب';
    }

    if (!formData.email.trim()) {
      newErrors.email = 'البريد الإلكتروني مطلوب';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'البريد الإلكتروني غير صحيح';
    }

    if (!formData.message.trim()) {
      newErrors.message = 'الرسالة مطلوبة';
    }

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  // إرسال النموذج عبر واتساب
  const handleSubmit = (e) => {
    e.preventDefault();
    
    if (validateForm()) {
      const whatsappUrl = createContactFormWhatsappUrl(formData);
      setShowToast(true);
      
      // فتح واتساب بعد ثانيتين
      setTimeout(() => {
        window.open(whatsappUrl, '_blank');
      }, 2000);
    }
  };

  // فتح واتساب مباشر
  const handleWhatsappClick = () => {
    const whatsappUrl = createWelcomeWhatsappUrl();
    window.open(whatsappUrl, '_blank');
  };

  // رسالة ماسنجر افتراضية
  const messengerUrl = createOrderMessengerUrl({ fullName: '', phone: '', municipality: '', state: '', notes: '', color: '', size: '', product: 'تواصل/استفسار' });

  return (
    <div className="contact-page" dir="rtl">
      <Container className="contact-container">
        {/* Main Content */}
        <Row className="main-content">
          {/* Policy Sections Horizontal */}
          <Col lg={8} className="legal-column-horizontal">
            <Row>
              <Col md={4} className="horizontal-policy-section">
                <h2 className="legal-title">شروط الاسترجاع</h2>
                <div className="legal-content">
                  يحق لك استرجاع أو استبدال المنتج خلال 7 أيام من تاريخ الاستلام إذا لم يكن على ما يرام أو إذا وُجدت به عيوب مصنعية، بشرط أن يكون المنتج في حالته الأصلية مع الإيصال الأصلي.
                </div>
              </Col>
              <Col md={4} className="horizontal-policy-section">
                <h2 className="legal-title">شروط الخدمة</h2>
                <div className="legal-content">
                  باستخدامك لهذا الموقع، فإنك توافق على الالتزام بكافة الشروط والأحكام المعروضة. نحتفظ بحق تعديل أو تحديث أي جزء من الخدمات في أي وقت دون إشعار مسبق.
                </div>
              </Col>
              <Col md={4} className="horizontal-policy-section">
                <h2 className="legal-title">سياسة الخصوصية</h2>
                <div className="legal-content">
                  نحترم خصوصيتك ونلتزم بحماية معلوماتك الشخصية وعدم مشاركتها مع أي طرف ثالث إلا بإذن منك أو حسب ما يقتضيه القانون.
                </div>
              </Col>
            </Row>
          </Col>

          {/* Right Column - Contact Information */}
          <Col lg={4} className="info-column">
            <div className="contact-info-section">
              <h2 className="info-title">تواصل معنا</h2>
              <p className="info-description">
                يسعدنا أن نسمع منك. سواء كان لديك سؤال حول منتجاتنا أو أسعارنا أو أي شيء آخر، فإن فريقنا جاهز للإجابة على جميع أسئلتك.
              </p>
              {/* Contact Methods */}
              <div className="contact-methods">
                <div className="contact-method">
                  <div className="method-info">
                    <span className="method-label">الهاتف</span>
                    <span className="method-value">{contactData.phone}</span>
                  </div>
                  <div className="method-icon phone-icon">📞</div>
                </div>
                <div className="contact-method">
                  <div className="method-info">
                    <span className="method-label">واتساب</span>
                    <span className="method-value whatsapp-text">تحدث معنا</span>
                  </div>
                  <div className="method-icon whatsapp-icon" onClick={handleWhatsappClick}>
                    <img src='/img/watsap.png' alt='' style={{width:"50px", height:"50px"}}  />
                  </div>
                </div>
                <div className="contact-method">
                  <div className="method-info">
                    <span className="method-label">ماسنجر</span>
                    <span className="method-value facebook-text">تحدث معنا</span>
                  </div>
                  <div className="method-icon messenger-icon" onClick={() => window.open(messengerUrl, '_blank')} style={{cursor:'pointer'}}>
                    <i className="bi bi-messenger" style={{ fontSize: '2rem', color: '#2F3E46', verticalAlign: 'middle' }}></i>
                  </div>
                </div>
                <div className="contact-method">
                  <div className="method-info">
                    <span className="method-label">فيسبوك</span>
                    <span className="method-value facebook-text">تابع تحديثاتنا</span>
                  </div>
                  <div className="method-icon facebook-icon" onClick={() => window.open(contactData.facebookUrl, '_blank')}>
                    <img src='/img/fac.png' alt='' style={{width:"50px", height:"50px"}}  />
                  </div>
                </div>
              </div>
              {/* Location Section */}
              <div className="location-section">
                <h3 className="location-title">مركزنا</h3>
                <p className="location-description">
                  نقوم بالتوصيل إلى جميع أنحاء البلاد، ويقع مركز التوصيل الرئيسي لدينا في البليدة.
                </p>
              </div>
            </div>
          </Col>
        </Row>
      </Container>

      

      {/* Toast للتأكيد */}
      <ToastContainer position="top-center" className="toast-container">
        <Toast 
          show={showToast} 
          onClose={() => setShowToast(false)}
          className="success-toast"
          delay={5000}
          autohide
        >
          <Toast.Header>
            <strong className="me-auto">تأكيد الإرسال</strong>
          </Toast.Header>
          <Toast.Body>
            سيتم تحويلك إلى واتساب لإرسال رسالتك
          </Toast.Body>
        </Toast>
      </ToastContainer>
    </div>
  );
};

export default ContactPage;
